import React from 'react';

import { HStack, useBreakpointValue, VStack } from 'native-base';

import type { IStackProps } from 'native-base';

/**
 * Converts a standard flex-direction value to one supported by breakpoints
 * @param flexDirection flex-direction value
 * @returns breakpoint syntax flex-drection value
 */
const getFlexDirection = (flexDirection?: IStackProps['flexDirection']) => {
  if (!flexDirection) {
    return { base: 'row' };
  }

  if (typeof flexDirection === 'object') {
    return flexDirection;
  } else if (typeof flexDirection === 'string') {
    return { base: flexDirection };
  }

  return { base: 'row' };
};

const GridRow = ({ flexDirection, ...props }: IStackProps, ref?: any) => {
  const _flexDirection = useBreakpointValue(getFlexDirection(flexDirection));

  if (_flexDirection === 'row') {
    return (
      <HStack
        flexDirection={_flexDirection}
        ref={ref}
        space="6"
        width="100%"
        {...props}
      />
    );
  }

  return (
    <VStack
      flexDirection={_flexDirection}
      ref={ref}
      space="6"
      width="100%"
      {...props}
    />
  );
};

export default React.memo(React.forwardRef(GridRow));
